import React from 'react';

import { useGlobalStoreState } from '@store/global/GlobalStore';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';

interface ThemeProviderProps {
  children: React.ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const globalTheme = useGlobalStoreState(state => state.theme.theme);

  return (
    <MuiThemeProvider theme={globalTheme}>
      {children}
    </MuiThemeProvider>
  );
};